"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NAME = exports.rule = void 0;
const GenericValidator_1 = require("./GenericValidator");
const isValid = require("is-valid-path");
/**
 * {
 *   type: 'VALID_URL_PATH',
 * }
 */
exports.rule = (config) => new GenericValidator_1.GenericValidator(config, (value) => isValid(value), "Value '%s' is not a valid URL path");
exports.NAME = 'VALID_URL_PATH';
//# sourceMappingURL=ValidUrlPathRule.js.map